export const RoleAccessAPI = {
  list: "role",
  create: "role",
  edit: "role",
  view: "role/view",
};
